import React, { useRef, useEffect } from 'react';
// import '../Style/PrintContentStyle.scss'
// import Logo from '../Images/accountreelogo.png'
// import Table from 'react-bootstrap/Table';
// import PrintButton from './PrintButton';
import { AiOutlinePrinter } from "react-icons/ai";
import { FaPrint } from "react-icons/fa";
import { ApiLink } from '../APILink/ApiLink';
import JsBarcode from 'jsbarcode';
import QRCode from 'react-qr-code';
import { AddActionsButton } from '../Components/AddElementsButton';


const PrintFletProdhimin = (props) => {
    const printElectronicSeal = props.hasElectronicSeal ? props.hasElectronicSeal : false;
    const inv = `PRD-${props.details && props.details.length > 0 ? props.details[0].FiscalYear : 0}-${props.details && props.details.length > 0 ? props.details[0].InvoiceNr : 0}`;
    const tableRef = useRef();
    const handlePrint = () => {
        const table = tableRef.current;

        if (!table) {
            console.error("Table reference not found.");
            return;
        }

        // Krijo një dritare të re për printim
        const printWindow = window.open('', 'PrintWindow', 'height=400,width=600');

        if (!printWindow) {
            console.error("Print window could not be opened.");
            return;
        }

        // Vendos përmbajtjen HTML dhe titullin
        printWindow.document.open();
        printWindow.document.write(`
            <html>
            <head>
                <title>Print Table Data</title> <!-- Titulli i dritares -->
                <style>
                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    table, th, td {
                        border: 1px solid black;
                    }
                    th, td {
                        padding: 8px;
                        text-align: left;
                    }
                </style>
            </head>
            <body>
                ${table.outerHTML}
            </body>
            </html>
        `);

        // Siguro që titulli të jetë i ndryshuar
        printWindow.document.title = inv;
        printWindow.document.close();

        // Fokusohu te dritarja e printimit dhe inicio printimin
        printWindow.focus();
        printWindow.print();

        // Opsionale: Mbyll dritaren pas printimit
        printWindow.close();
    };

    return (
        <div>
            <div style={{ display: "none" }}>
                <div className='PrintContent__Container' ref={tableRef} style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                    <div className='PrintContent__Container__div2' style={{ display: "flex", justifyContent: "space-between", paddingLeft: "15px", paddingRight: "15px", height: "auto" }}>
                        <div className='PrintContent__Container__div2__logo' style={{ width: "300px", height: "130px" }}>
                            {(props.companyDetails && props.companyDetails.length > 0 && props.companyDetails[0]?.CompanyLogo) ? (
                                <img src={ApiLink.PHOTO_URL + props.companyDetails[0].CompanyLogo} style={{ width: "200px", height: "120px" }} className="printLogo" />
                            ) : (
                                <span>No logo available</span>
                            )}
                        </div>

                        <div className='PrintContent__Container__div2__data' style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", padding: "5px" }}>
                            <label style={{ fontSize: "12px" }}><b>Kompania: {props.companyDetails && props.companyDetails.length > 0 ? (props.companyDetails[0].CompanyName) : ''}</b></label>
                            <label style={{ fontSize: "12px" }}>NUI: {props.companyDetails && props.companyDetails.length > 0 ? (props.companyDetails[0].IdentificationNumber) : ''}</label>
                            {
                                props.companyDetails && props.companyDetails.length > 0 && props.companyDetails[0].VATDeclarant != 0 ?
                                    (
                                        <label style={{ fontSize: "12px" }}>Numri i TVSH-së: {props.companyDetails[0].VATNumber}</label>
                                    )
                                    :
                                    null
                            }
                            <label style={{ fontSize: "12px" }}>Adresa: {props.companyDetails && props.companyDetails.length > 0 ? (props.companyDetails[0].Address) : ''}</label>
                            <label style={{ fontSize: "12px" }}>Tel: {props.companyDetails && props.companyDetails.length > 0 ? (props.companyDetails[0].PhoneNumbers) : ''}</label>
                            <label style={{ fontSize: "12px" }}>Email: {props.companyDetails && props.companyDetails.length > 0 ? (props.companyDetails[0].Email) : ''}</label>
                        </div>
                    </div>
                    <hr style={{ margin: "10px" }}></hr>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", marginLeft: "10px", marginRight: "10px" }}>
                        <h2><b>Fletëprodhim</b></h2>
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
                                <label style={{ fontSize: "12px" }}>Njesia Organizative:<b> {props.details && props.details.length > 0 ? props.details[0].UnitName : 0}</b></label>
                                <label style={{ fontSize: "12px" }}>Menaxheri i Prodhimit: <b>{props.details.length > 0 && props.details[0].CreatedByUser ? props.details[0].CreatedByUser.split('@')[0] : ''}</b></label>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", textAlign: "right" }}>
                                <label style={{ fontSize: "12px" }}>Numri i Fleteprodhimit: <b>{`PRD-${props.details && props.details.length > 0 ? props.details[0].FiscalYear : 0}-${props.details && props.details.length > 0 ? props.details[0].InvoiceNr : 0}`}</b></label>
                                <label style={{ fontSize: "12px" }}>Data e Fleteprodhimit: <b>{props.details.length > 0
                                    ? new Date(props.details[0].Date).toLocaleDateString("en-GB")
                                    : ''}</b></label>
                            </div>
                        </div>
                    </div>
                    <hr style={{ margin: "10px" }}></hr>
                    <div style={{ marginLeft: "10px", marginRight: "10px", display: "flex", flexDirection: "column" }}>
                        <label style={{ fontSize: "14px" }}><b>Artikulli i Prodhuar</b></label>
                        <label style={{ fontSize: "12px" }}>Këtu është artikulli në detaje, i cili është prodhuar</label>
                    </div>
                    <hr style={{ margin: "10px" }}></hr>
                    <div style={{ marginLeft: "10px", marginRight: "10px" }}>
                        <table className='PrintTable' style={{ width: "100%", borderCollapse: "collapse" }}>
                            <tbody>
                                <tr style={{ borderBottom: "1px solid black " }}>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "60px" }}>#</th>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "300px" }}>Emertimi</th>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "120px" }}>Njesia</th>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "right", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "120px" }}>Sasia e Prodhuar</th>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "right", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "120px" }}>Kostoja për njësi</th>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "right", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "120px" }}>Vlera e Kostos</th>
                                </tr>
                                {props.produceArticle &&
                                    props.produceArticle.map((data, index) => (
                                        <tr style={{ borderBottom: "1px solid black " }} key={data.HistoryID}>
                                            <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px", width: "60px" }}>
                                                {++index}
                                            </td>
                                            <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px", width: "300px" }}>
                                                {data.ArticleName}
                                            </td>
                                            <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px", width: "120px" }}>
                                                {data.UnitName}
                                            </td>
                                            <td style={{ padding: "3px", border: "1px solid black", textAlign: "right", fontSize: "10px", width: "120px" }}>
                                                {data?.Qty ? data.Qty.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                            </td>
                                            <td style={{ padding: "3px", border: "1px solid black", textAlign: "right", fontSize: "10px", width: "120px" }}>
                                                {data?.CmimiMesatar ? (`${data.CmimiMesatar.toLocaleString('en-US', { minimumFractionDigits: 2 })}€`) : '0.00€'}
                                            </td>
                                            <td style={{ padding: "3px", border: "1px solid black", textAlign: "right", fontSize: "10px", width: "120px" }}>
                                                {data?.TotalAmount ? (`${data.TotalAmount.toLocaleString('en-US', { minimumFractionDigits: 2 })}€`) : '0.00€'}
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ width: "70%" }}>
                        </div>
                        <div style={{ margin: "10px" }}>
                            <table className='PrintTable' style={{ display: "flex", justifyContent: "flex-end" }}>
                                <tbody>
                                    <tr >
                                        <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "12px", width: "100px" }}>Kostoja Totale:</th>
                                        <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", textAlign: "right", fontSize: "12px", width: "100px" }}>
                                            {/* {(props.details && props.details.length > 0 ? (props.details[0].Total) : 0).toFixed(2)} € */}
                                            {props.produceArticle && props.produceArticle.length > 0 ? (props.produceArticle[0].TotalAmount !== null && props.produceArticle[0].TotalAmount !== 0 ? props.produceArticle[0].TotalAmount.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00') : '0.00'} €
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <hr style={{ margin: "10px" }}></hr>
                    <div style={{ marginLeft: "10px", marginRight: "10px", display: "flex", flexDirection: "column" }}>
                        <label style={{ fontSize: "14px" }}><b>Recepturat</b></label>
                        <label style={{ fontSize: "12px" }}>Këto janë recepturat e detajuara, të cilat kanë hyrë në prodhim</label>
                    </div>
                    <hr style={{ margin: "10px" }}></hr>
                    <div style={{ marginLeft: "10px", marginRight: "10px" }}>
                        <table className='PrintTable' style={{ width: "100%", borderCollapse: "collapse" }}>
                            <tbody>
                                <tr style={{ borderBottom: "1px solid black " }}>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "60px" }}>#</th>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "300px" }}>Emertimi</th>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "120px" }}>Njesia</th>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "right", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "120px" }}>Sasia</th>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "right", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "120px" }}>Cmimi i Recepturës</th>
                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "right", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "120px" }}>Vlera e Recepturës</th>
                                </tr>
                                {props.recepture &&
                                    props.recepture.map((data, index) => (
                                        <tr style={{ borderBottom: "1px solid black " }} key={data.HistoryID}>
                                            <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px", width: "60px" }}>
                                                {++index}
                                            </td>
                                            <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px", width: "300px" }}>
                                                {data.recepture}
                                            </td>
                                            <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px", width: "120px" }}>
                                                {data.artUnit}
                                            </td>
                                            <td style={{ padding: "3px", border: "1px solid black", textAlign: "right", fontSize: "10px", width: "120px" }}>
                                                {data?.qty ? data.qty.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                            </td>
                                            <td style={{ padding: "3px", border: "1px solid black", textAlign: "right", fontSize: "10px", width: "120px" }}>
                                                {data?.price ? (`${data.price.toLocaleString('en-US', { minimumFractionDigits: 2 })}€`) : '0.00€'}
                                            </td>
                                            <td style={{ padding: "3px", border: "1px solid black", textAlign: "right", fontSize: "10px", width: "120px" }}>
                                                {data?.value ? (`${data.value.toLocaleString('en-US', { minimumFractionDigits: 2 })}€`) : '0.00€'}
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ width: "70%" }}>
                        </div>
                        <div style={{ margin: "10px" }}>
                            <table className='PrintTable' style={{ display: "flex", justifyContent: "flex-end" }}>
                                <tbody>
                                    <tr >
                                        <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "12px", width: "100px" }}>Kostoja Totale:</th>
                                        <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", textAlign: "right", fontSize: "12px", width: "100px" }}>
                                            {/* {(props.details && props.details.length > 0 ? (props.details[0].Total) : 0).toFixed(2)} € */}
                                            {props.produceArticle && props.produceArticle.length > 0 ? (props.produceArticle[0].TotalAmount !== null && props.produceArticle[0].TotalAmount !== 0 ? props.produceArticle[0].TotalAmount.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00') : '0.00'} €
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div style={{ position: "fixed", bottom: 0, width: "100%", backgroundColor: "white", marginLeft: "10px", marginRight: "10px" }}>
                        <div className='PrintContent__Container__div7' style={{ display: "flex", justifyContent: "flex-start" }}>
                            {
                                printElectronicSeal ?
                                    <>
                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginLeft: "10px", marginRight: "10px" }}>
                                            <div style={{ border: "solid 1px blue", display: "flex", flexDirection: "column", alignItems: "center", paddingLeft: "10px", paddingRight: "10px" }}>
                                                <label style={{ color: "blue", fontSize: "11px" }}>{props.companyDetails && props.companyDetails.length > 0 ? (props.companyDetails[0].CompanyName) : ''}</label>
                                                <label style={{ color: "green", fontSize: "11px" }}>Konfirmuar</label>
                                                <label style={{ color: "blue", fontSize: "11px" }}>VULA ELEKTRONIKE</label>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                <label style={{ color: "blue", marginBottom: "-15px", fontSize: "12px" }}>
                                                    {props.details.length > 0 && props.details[0].CreatedByUser ? props.details[0].CreatedByUser.split('@')[0] : ''}
                                                </label>
                                                <span>_________________________</span>
                                                <label style={{ fontSize: "10px" }}>Menaxheri Prodhimit:</label>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    < >
                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginLeft: "10px", marginRight: "10px" }}>
                                            <span>_________________</span>
                                            <label style={{ fontSize: "10px" }}>Menaxheri Prodhimit:</label>
                                        </div>
                                    </>
                            }
                        </div>
                        <hr style={{ margin: "10px" }} />
                        <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", marginRight: "10px", backgroundColor: "lightgray" }}>
                            <label style={{ fontSize: "14px" }}><b>Recepturat</b></label>
                            <label style={{ fontSize: "12px" }}>Ky fletëprodhim përshkruan procesin e prodhimit sipas normativave standarde të përcaktuara në modulin e normativave të Accountree.</label>
                        </div>
                        <hr style={{ margin: "10px" }} />
                        <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", marginRight: "10px", backgroundColor: "lightgray" }}>
                            <label style={{ fontSize: "14px" }}><b>Përmbledhje</b></label>
                            <label style={{ fontSize: "12px" }}>{props.details && props.details.length > 0 ? props.details[0].Comment : ''}</label>

                        </div>
                        <hr style={{ margin: "10px" }} />
                        <div style={{ display: "flex", justifyContent: "flex-end", marginLeft: "10px", marginRight: "10px" }}>
                            <label style={{ marginRight: "10px", fontSize: "10px", }}><b>© Quantify Nexus L.L.C | www.accountree.net</b></label>
                        </div>
                    </div>
                </div>
            </div>
            <AddActionsButton
                text="Print"
                onClick={handlePrint}
                icon={<FaPrint />}
                className="button-15"
            />
        </div>
    );
};

export default PrintFletProdhimin;
